import { inject, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { EcmMaterialModule, MaterialSeoService } from '@ecm/material';

import { dashboardTranslationFr } from './i18n/fr';

@NgModule({
    imports: [EcmMaterialModule, RouterModule],
    providers: [MaterialSeoService],
})
export class EcmDashboardModule {
    private readonly translate = inject(TranslateService);

    public constructor() {
        this.translate.setTranslation('fr', dashboardTranslationFr, true);
    }
}
